import { useWindowSize } from '@Components/Utilities/WindowSize';
import translator from '@Components/Utilities/Translator';
import HeaderLink from '@Components/Header/HeaderLink';
import HamburgerMenu from '@Components/Header/HamburgerMenu';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { useRef, useState, useEffect } from 'react';
import { sandhillsRequest, getURLParameter } from '@Components/Utilities/SandhillsUtility';
import { setLocalStorageValue } from '@Components/Utilities/CookieHelper';
import { LoginPromptEvents } from '@Components/Utilities/SandhillsConstants';

const QuickFind = loadable(() => import('@Components/Header/QuickFind'));
const SiteSelector = loadable(() => import('@Components/Header/SiteSelector'));
const AppBanner = loadable(() => import('@Components/Shared/AppBanner'));
const SignInForBestExperienceModal = loadable(() => import('@Components/Shared/Modals/SignInForBestExperienceModal'));
const LoginPromptModal = loadable(() => import('@Components/Shared/Modals/LoginPromptModal'));
const Modal = loadable(() => import('@Components/Shared/Modals/Modal'));


const HeaderView = (props) => {

    const {
        loginPromptEventId,
        pageName,
        siteName,
        IsAuctionResults,
        showLoginPromptSiteSetting
    } = props;

    const routes = useRecoilValue(atoms.routes);
    const currentUser = useRecoilValue(atoms.currentUser);
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const windowSize = useWindowSize();
    const hasListingsInput = props.Links.filter(lnk => lnk.Key == 'lnkListingsInput' && lnk.ShowOnDesktop).length > 0;
    const listingInputLink = hasListingsInput && props.Links.filter(lnk => lnk.Key == 'lnkListingsInput' && lnk.ShowOnDesktop)[0];
    const featuredLinks = props.Links.filter(lnk => lnk.Key !== 'lnkListingsInput' && lnk.Groups.includes('BottomRowFeaturedLinks') && lnk.ShowOnDesktop);
    const [signInModal, setSignInModal] = useState(!currentUser.IsAuthenticated && !currentSite.Site.IsHostedSite && !currentUser.IsSearchEngine);
    const [isScrollable, setIsScrollable] = useState(false)
    const [scrolledLeft, setScrolledLeft] = useState(true);
    const [scrolledRight, setScrolledRight] = useState(false);
    const scrollRef = useRef();
    const [emailPhonePopupVisible, setEmailPhonePopupVisible] = useState(false);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    //only show loginPrompt if they are not logged in and it's not a hosted site and not a bot.
    const [showLoginPrompt, setShowLoginPrompt] = useState(showLoginPromptSiteSetting && !currentUser?.IsAuthenticated && !currentSite.Site.IsHostedSite && !currentUser.IsSearchEngine);
    const [modalQSVisible, setModalQSVisible] = useState(true);

    useEffect(() => {
        if (currentSite.Site.IsBidcaller) {
            showVerificationPopup();
        }
    }, []);

    useEffect(() => {
        scrollingArrows();
    }, [scrollRef.current]);

    useEffect(() => {
        checkForQSModalParam();
    }, []);

    const scrollingArrows = () => {
        const element = scrollRef.current;

        if (element) {
            setIsScrollable(element.scrollWidth > element.clientWidth);

            if (element.scrollLeft === 0) {
                //Scrolled all the way left
                setScrolledLeft(true);
                setScrolledRight(false);
            }
            else if (element.scrollLeft + element.clientWidth === element.scrollWidth) {
                //Scrolled all the way right
                setScrolledRight(true);
                setScrolledLeft(false);
            } else {
                //Scroll is in the middle
                setScrolledLeft(false);
                setScrolledRight(false);
            }
        }
    }

    const showVerificationPopup = () => {
        sandhillsRequest({
            url: "/ajaxcontent/ValidateEmailPhone",
            method: 'POST',
            errorHandling: {
            message: 'An error occurred while obtaining verification dates',
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        }).then((response) => {
            if (response) {
                setEmail(response.Email);
                setPhone(response.Phone);
                setEmailPhonePopupVisible(true);
            }            
        });
    }

    const closeVerificationPopup = () => {
        setEmailPhonePopupVisible(false);
    }

    const verificationPopupUpdateInfo = () => {
        sandhillsRequest({
            url: "/ajaxcontent/UpdateEmailPhoneVerification",
            method: 'POST',
            errorHandling: {
                message: 'An error occurred while obtaining verification dates',
                showDetails: true,
                useConsole: true,
                useAlert: false
            }
        })
    }

    const confirmPopup = () => {
        closeVerificationPopup();
        verificationPopupUpdateInfo();
    }

    const closeLoginPrompt = () => {
        setLocalStorageValue(LoginPromptEvents.loginPromptLastClosed.Text, new Date());
        setShowLoginPrompt(false);
    };

    const checkForQSModalParam = () => {
        if (getURLParameter(window.location.href, "sam") || getURLParameter(window.location.href, "samw") || getURLParameter(window.location.href, "mao") || getURLParameter(window.location.href, "tsu")) {
            setModalQSVisible(true);
            return;
        }
        setModalQSVisible(false);
    };

    const emailPhonePopup = () => {
        return (
            <Modal containerClassName='verification-modal-content' onEscapeKeyClose={closeVerificationPopup}>
                <Modal.Header onClose={closeVerificationPopup}>
                    <Modal.Title>
                        {translator.translate('sandhills.emailphoneverification')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <hr />
                    <p className='top-explanation'>{translator.translate("sandhills.pleaseverifybelowvalues")}:</p>
                    <div className='email-phone-values'>
                        <div className='email'>
                            <label>{translator.translate("email") }</label>
                            <input className='email-input' type='text' value={email} readOnly />
                        </div>
                        <div></div>
                        <div className='phone'>
                            <label>{translator.translate("sandhills.Phone") }</label>
                            <input className='phone-input' type='text' value={phone} readOnly />
                        </div>
                    </div>
                    <div className='bottom-buttons'>
                        <a className='update-button' href={props.Links[3].SubMenu.Links[2].Url}>{translator.translate("sandhills.update")}</a>
                        <button className='ts-button confirm-button' onClick={confirmPopup}>{translator.translate("sandhills.confirm")}</button>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }

    return (
        <>
            {emailPhonePopupVisible && emailPhonePopup()}
            {props.LocalhostSites && <SiteSelector {...props} />}
            <header className='site-header no-print'>
                {(showLoginPrompt && !modalQSVisible) && <LoginPromptModal onClose={closeLoginPrompt} loginPromptEventId={loginPromptEventId} pageName={pageName} siteName={siteName} IsAuctionResults={IsAuctionResults} isMobile={windowSize.isMobile} />}
                {!currentSite?.IsMobileAppContext &&
                    <>
                    {props.AppDownloadLink && windowSize.isMobile &&
                        <div className='app-banner' style={{ zIndex: signInModal ? 1504 : 'unset', position: 'relative' }}>
                            <AppBanner AppDownloadLink={props.AppDownloadLink} AppLogo={props.AppLogo} IsAppleDevice={props.IsAppleDevice} />
                        </div>
                    }
                        <div className='top-row'>
                            <nav className='top-row-content' style={{ zIndex: signInModal ? 1504 : 'unset' }}>
                                <div className='auth-container mobile-hide'>
                                    <div className={currentUser.IsAuthenticated ? 'logged-in' : 'logged-out'}>
                                        {currentSite.Site.IsAuctionTime ?
                                            <ul className='account-dropdown'>
                                                {props.Links.filter(lnk => lnk.Groups.includes('AuthLinks') && lnk.ShowOnDesktop).map(lnk =>
                                                    <li key={lnk.Key}>
                                                        <HeaderLink {...lnk} />
                                                    </li>
                                                )}
                                            </ul>
                                            :
                                            <>
                                                {props.Links.filter(lnk => lnk.Groups.includes('AuthLinks') && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                            </>
                                        }

                                        {currentSite.Site.IsAuctionTime &&
                                            <>
                                        {props.Links.filter(lnk => lnk.Groups.includes('WatchlistLinks') && lnk.ShowOnDesktop).map(lnk =>
                                            <a href={routes.WatchList} className="watchlist-dropdown-link">
                                                <ul className="watchlist-dropdown">
                                                    <li key={lnk.Key}>
                                                        <HeaderLink {...lnk} />
                                                    </li>
                                                </ul>
                                            </a>
                                                )}
                                            </>
                                        }
                                                                               
                                    </div>
                                </div>
                                <div className='additional-header-links'>
                                    {props.Links.filter(lnk => lnk.Key == 'lnkQuoteMessageAlert' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} QuoteMessageAlert={props.QuoteMessageAlert} />)}
                                    {props.Links.filter(lnk => lnk.Key == 'lnkWebsiteHosting' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    {props.Links.filter(lnk => lnk.Key == 'lnkAdvertising' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    {props.Links.filter(lnk => lnk.Key == 'lnkAdvertisingPhone' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    {props.Links.filter(lnk => lnk.Key == 'lnkContactUs' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    {currentSite.Site.IsAuctionTime ?
                                        <ul className='lang-dropdown'>                                          
                                            {props.Links.filter(lnk => lnk.Key == 'lnkLangSelector' && lnk.ShowOnDesktop).map(lnk =>
                                                <li key={lnk.Key}>
                                                    <HeaderLink isLangSelector={true} {...lnk} />
                                                </li>
                                            )}                                            
                                        </ul>
                                        :
                                        <>                                           
                                            {props.Links.filter(lnk => lnk.Key == 'lnkLangSelector' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}                                            
                                        </>
                                    }
                                    {props.Links.filter(lnk => lnk.Key == 'lnkMBKCanada' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    {props.Links.filter(lnk => lnk.Key == 'lnkGlobalBrands' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    
                                </div>
                                {signInModal && !windowSize.isMobile &&
                                    <div className='sign-in-container'>
                                        <SignInForBestExperienceModal
                                            onClose={(e) => { setSignInModal(false); }}
                                            links={props.Links}
                                        />
                                    </div>
                                }
                            </nav>
                        </div>
                        <div className='middle-row' style={{ zIndex: (signInModal && windowSize.isMobile && !currentSite.IsMobileAppContext) ? 1504 : 'unset', position: 'relative' }}>
                            <div className='middle-row-content'>
                                <div className='logo'>
                                    <a href={props.HomeUrl} className='main-logo-link'>
                                        <img className='main-logo' alt={props.LogoImageAltText} src={props.LogoUrl} />
                                    </a>
                                </div>
                                {windowSize.isMobile && props.Links.filter(lnk => lnk.Key == 'lnkQuoteMessageAlert' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} QuoteMessageAlert={props.QuoteMessageAlert} />)}
                                {windowSize.isMobile && <HamburgerMenu {...props} />}
                                {!windowSize.isMobile && <QuickFind placeholder={props.QuickFindPlaceholder} actionurl={props.QuickFindActionURL} searchTypes={props.QuickFindSearchTypes} partsUrl={props.PartsSearchURL} attachmentsUrl={props.AttachmentsSearchURL} />}
                            </div>
                            {signInModal && windowSize.isMobile && !currentSite.IsMobileAppContext &&
                                <div className='sign-in-container'>
                                    <SignInForBestExperienceModal
                                        onClose={(e) => { setSignInModal(false); }}
                                        links={props.Links}
                                    />
                                </div>
                            }
                        </div>
                    </>
                }
                {windowSize.isMobile && featuredLinks.length > 0 &&
                    <div className='bottom-row'>
                        <div className='bottom-row-content'>
                            <div className='bottom-row-featured-links' onScroll={scrollingArrows} ref={scrollRef}>
                                {isScrollable && (currentSite?.Site?.IsBidcaller || currentSite.IsAuctionTimeAuctionSite) &&
                                    <>
                                        {!scrolledLeft ?
                                            <>
                                                <div className='left-header-arrow fade-in'>
                                                    <i className='fas fa-chevron-left' />
                                                </div>
                                                {scrolledRight ?
                                                    <div className='right-header-arrow fade-out'>
                                                        <i className='fas fa-chevron-right' />
                                                    </div> :
                                                    <div className='right-header-arrow'>
                                                        <i className='fas fa-chevron-right' />
                                                    </div>
                                                }
                                            </> :
                                            (!scrolledRight &&
                                                <>
                                                    <div className='right-header-arrow'>
                                                        <i className='fas fa-chevron-right' />
                                                    </div>

                                                    {scrolledLeft ?

                                                        <div className='left-header-arrow fade-out'>
                                                            <i className='fas fa-chevron-left' />
                                                        </div> :
                                                        <div className='left-header-arrow fade-in'>
                                                            <i className='fas fa-chevron-left' />
                                                        </div>
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                }
                                {featuredLinks.map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                            </div>
                        </div>
                    </div>
                }
                <div className='bottom-row' style={{ zIndex: (signInModal && currentSite.IsMobileAppContext) ? 1504 : 'unset', position: 'relative' }}>
                    <div className='bottom-row-content'>
                        <div className='bottom-row-buttons'>
                            {windowSize.isMobile &&
                                <div className='quickfind-container'>
                                    <QuickFind placeholder={props.QuickFindPlaceholder} actionurl={props.QuickFindActionURL} searchTypes={props.QuickFindSearchTypes} partsUrl={props.PartsSearchURL} attachmentsUrl={props.AttachmentsSearchURL} />
                                </div>
                            }
                            <div className='bottom-row-buttons-row'>
                                {hasListingsInput &&
                                    <a id='sell-your-button' href={listingInputLink.Url} className='sell-btn' target='_blank'>
                                        {listingInputLink.Text}
                                        <i className='fas fa-chevron-right' />
                                        <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>
                                    </a>}
                                {props.Links.filter(lnk => lnk.Key == 'lnkSerialNumberGuide' && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                {props.Links.filter(lnk => lnk.Key == 'lnkShipWithFr8Star').map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                {props.Links.filter(lnk => lnk.Key == 'lnkGetFinance').map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                            </div>
                            {props.Links.filter(lnk => lnk.Key == 'lnkAdvertisingPhone' && lnk.ShowOnDesktop).map(lnk => {
                                var lnkCTA = Object.assign({}, lnk);
                                lnkCTA.Text = translator.translate('sandhills.tradepubwebsite.mvc.calltoadvertise') + ': ' + lnk.Text;
                                return <HeaderLink key={lnkCTA.Key + '_cta'} {...lnkCTA} ClassName={'call-btn'} />
                            })}
                        </div>
                        <>
                            <div className='bottom-row-links'>
                                {currentSite.Site.IsAuctionTime ?
                                    <ul className='category-dropdown'>
                                        {props.Links.filter(lnk => lnk.Key !== 'lnkListingsInput' && lnk.Groups.includes('BottomRowLinks') && lnk.ShowOnDesktop).map(lnk => (
                                            <li key={lnk.key}>
                                                <HeaderLink {...lnk} />
                                            </li>
                                        ))}
                                    </ul>
                                    :
                                    <>
                                        {props.Links.filter(lnk => lnk.Key !== 'lnkListingsInput' && lnk.Groups.includes('BottomRowLinks') && lnk.ShowOnDesktop).map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    </>
                                }
                            </div>
                        </>
                    </div>
                    {signInModal && currentSite.IsMobileAppContext &&
                        <div className='sign-in-container'>
                            <SignInForBestExperienceModal
                                onClose={(e) => { setSignInModal(false); }}
                                links={props.Links}
                                mobileApp={currentSite.IsMobileAppContext}
                            />
                        </div>
                    }
                </div>
                {!windowSize.isMobile && featuredLinks.length > 0 &&
                    <div className='bottom-row'>
                        <div className='bottom-row-content'>
                            <div className='bottom-row-featured-links'>
                                {currentSite.Site.IsAuctionTime ?
                                    <ul className='category-dropdown'>
                                        {featuredLinks.map(lnk => (
                                            <li key={lnk.key}>
                                                <HeaderLink featured={true} {...lnk} />
                                            </li>
                                        ))}
                                    </ul>
                                    :
                                    <>
                                        {featuredLinks.map(lnk => <HeaderLink key={lnk.Key} {...lnk} />)}
                                    </>
                                }
                                
                            </div>
                        </div>
                    </div>
                }
            </header>
        </>
    );
};

export default HeaderView;
global.HeaderView = HeaderView;